import { AppRoute } from 'app/app-layout/constants/index';
import { NavCategoryId } from 'app/app-layout/models/nav/nav-category-ids.enum';
import { NavItemPrimary } from 'app/app-layout/models/nav/nav-item-primary.model';
import { NavItemSecondary } from 'app/app-layout/models/nav/nav-item-secondary.model';
import { AppScopes } from 'app/core/authentication/models/scopes.enum';

export class TrainingNavItem extends NavItemPrimary {
  constructor() {
    super({
      labelId: '$link_training',
      categoryId: NavCategoryId.TRAINING,
      categoryIcon: 'ico-nav-training.svg',
      route: AppRoute.training,
      menuItems: [
        new TrainingLibraryNavItem(),
      ],
    });
  }
}

export class TrainingLibraryNavItem extends NavItemSecondary {
  constructor() {
    super({
      labelId: '$link_training',
      scopes: [
        AppScopes.EMPLOYEE_TRAINING_ACCESS,
      ],
      route: AppRoute.training,
      categoryId: NavCategoryId.TRAINING,
    });
  }
}
